var scrollable = {
    base: {
        bg: "white",
        "&[data-scroll-up=true]": {
            "[data-scroll-shadow-top]": {
                boxShadow: "0 2em 2em -1em var(--shadow-top-color) inset",
            },
        },
        "&[data-scroll-down=true]": {
            "[data-scroll-shadow-bottom]": {
                boxShadow: "0 -2em 2em -1em var(--shadow-bottom-color) inset",
            },
        },
        "&[data-scroll-left=true]": {
            "[data-scroll-shadow-top]": {
                boxShadow: "2em 0 1em -1em var(--shadow-top-color) inset",
            },
        },
        "&[data-scroll-right=true]": {
            "[data-scroll-shadow-bottom]": {
                boxShadow: "-2em 0 1em -1em var(--shadow-bottom-color) inset",
            },
        },
    },
};

export { scrollable };
//# sourceMappingURL=scrollable.js.map
